var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-new-order section-full"},[_c('form-staff',{attrs:{"title":_vm.$gettext('Add Staff')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }